import { useParams } from "react-router-dom";
import { Tooltip } from "antd";
import { showGlobalModal } from "components/GlobalModal";
import { useEffect, useRef, useState } from "react";
import { useGlobalState } from "state";

const ResetAndSubmit = ({ resetForm, submitLabel, isError, submitToolTip }: { resetForm?: any, submitLabel?: string, isError?: boolean, submitToolTip?: string }) => {

    let instituteData = null;
    const params = useParams();

    try {
        instituteData = JSON.parse(sessionStorage?.getItem('_DATA_') || '{}');
    } catch (err) { }

    const handleResetAndSubmit = () => {
        return ((params?.["*"] === "instituteInfo" || params?.["*"]?.split("/")?.[0] === "instituteInfo") && !!instituteData?.BRANCH_ID) ? false : true;
    }

    return handleResetAndSubmit() ? <div className="flex justify-end items-center gap-4 mt-2">
        {!!resetForm && <button
            type="button"
            className="px-[3vh] py-[1vh] text-[2vh] font-medium text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100"
            onClick={() => {
                showGlobalModal(`Do you want to reset ${params?.["*"] === "instituteInfo" ? "School Info".toUpperCase() : (params?.["*"]?.split("/")?.at(-1) || params?.["*"]).toUpperCase()}?`, "warning", {
                    showConfirm: true,
                    onConfirm: () => {
                        resetForm()
                    },
                    onCancel: () => {
                        console.log("User canceled deletion");
                    }
                });
            }}
        >
            Reset
        </button>}
        <Tooltip title={submitToolTip} placement="left">
            <button
                type="submit"
                disabled={isError}
                className={`${isError ? "opacity-25 " : " "} inline-flex items-center px-[3vh] py-[1vh] text-[2vh] font-medium text-center text-white bg-blue-700 rounded-md hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none`}
                style={{ color: 'white' }}
            >
                {submitLabel || "Next"}
            </button>
        </Tooltip>
    </div> : <></>
}

export default ResetAndSubmit;